
export const invoiceStatus = {
    inProgress: "InProgress",
    completed: "Completed"
}

export const PaymentStatus = {
    unpaid: "Unpaid",
    paid: "Paid",
    partlyPaid: "Partly Paid"
}
